import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialBuzzPage() {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [generating, setGenerating] = useState(false);
    const [results, setResults] = useState(null);

    const handleGenerate = (e) => {
        e.preventDefault();
        if (!name) return;
        setGenerating(true);

        // Simulate AI Gen
        setTimeout(() => {
            setResults([
                { id: 1, type: 'Instagram', title: 'Le Post "Lifestyle"', text: `🔥 ${name} change la donne !\n\nDécouvrez notre nouvelle collection exclusive. Qualité, style et élégance au rendez-vous. #NewBeginnings #${name.replace(/\s/g, '')}`, img: 'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?auto=format&fit=crop&w=600&q=80', gradient: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)' },
                { id: 2, type: 'Facebook', title: 'Le Post "Promo"', text: `📣 OFFRE DE LANCEMENT !\n\nPour fêter notre nouveau site, ${name} vous offre -20% toute cette semaine. Venez nous voir ! 👋`, img: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=600&q=80', gradient: '#1877f2' },
                { id: 3, type: 'LinkedIn', title: 'Le Post "Expert"', text: `🚀 Fiers d'annoncer la transformation digitale de ${name}.\n\nUne étape clé pour mieux servir nos clients et innover dans notre secteur.\n\nMerci à InfoColab pour l'accompagnement.`, img: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=600&q=80', gradient: '#0077b5' },
            ]);
            setGenerating(false);
        }, 2000);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#f0f2f5', color: '#1e293b', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column' }}>

            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 40 }}>
                <button onClick={() => navigate('/commercial/launchpad')} style={{ background: 'white', width: 50, height: 50, borderRadius: '50%', border: '1px solid #e2e8f0', color: 'black', fontSize: '1.5rem', cursor: 'pointer' }}>←</button>
                <div>
                    <h1 style={{ fontSize: '2.5rem', fontWeight: 800, margin: 0 }}>📣 Générateur de Buzz</h1>
                    <p style={{ opacity: 0.6, margin: 0 }}>Vos 3 premiers posts réseaux sociaux, prêts à l'emploi.</p>
                </div>
            </div>

            {!results ? (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <form onSubmit={handleGenerate} style={{ textAlign: 'center', width: '100%', maxWidth: 500 }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 20 }}>Quel est le nom de la marque ?</div>
                        <input
                            autoFocus
                            type="text" placeholder="Ex: Boulangerie Délice" value={name} onChange={e => setName(e.target.value)}
                            style={{ width: '100%', padding: '25px', borderRadius: 16, border: '2px solid #e2e8f0', fontSize: '1.5rem', textAlign: 'center', marginBottom: 30 }}
                        />
                        <button
                            type="submit" disabled={generating}
                            style={{
                                padding: '20px 50px', borderRadius: 50, border: 'none', background: generating ? '#cbd5e1' : 'black', color: 'white', fontSize: '1.5rem', fontWeight: 800, cursor: generating ? 'default' : 'pointer',
                                boxShadow: generating ? 'none' : '0 20px 40px -10px rgba(0,0,0,0.5)', transition: 'all 0.2s', transform: generating ? 'scale(0.95)' : 'scale(1)'
                            }}
                        >
                            {generating ? 'Création de la magie...' : 'Générer le Buzz ✨'}
                        </button>
                    </form>
                </div>
            ) : (
                <div style={{ flex: 1, display: 'flex', gap: 30, overflowX: 'auto', paddingBottom: 20, alignItems: 'center' }}>
                    {results.map((post, idx) => (
                        <div key={post.id} style={{
                            minWidth: 350, background: 'white', borderRadius: 24, overflow: 'hidden', boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)',
                            animation: `slideUp 0.5s ease-out ${idx * 0.2}s forwards`, opacity: 0, transform: 'translateY(50px)'
                        }}>
                            {/* Header Card */}
                            <div style={{ padding: 15, display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #f1f5f9' }}>
                                <div style={{ width: 40, height: 40, borderRadius: '50%', background: post.gradient, display: 'grid', placeItems: 'center', color: 'white', fontWeight: 700 }}>
                                    {name.charAt(0)}
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, fontSize: '0.9rem' }}>{name}</div>
                                    <div style={{ fontSize: '0.75rem', opacity: 0.5 }}>Sponsorisé • {post.type}</div>
                                </div>
                            </div>

                            {/* Image */}
                            <div style={{ height: 350, background: `url(${post.img})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />

                            {/* Footer */}
                            <div style={{ padding: 20 }}>
                                <div style={{ fontWeight: 700, marginBottom: 5 }}>{post.title}</div>
                                <p style={{ fontSize: '0.9rem', lineHeight: 1.5, opacity: 0.8, whiteSpace: 'pre-wrap' }}>{post.text}</p>
                                <button style={{ width: '100%', marginTop: 20, padding: 12, background: '#f1f5f9', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>Télécharger</button>
                            </div>
                        </div>
                    ))}
                    <div style={{ minWidth: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <button onClick={() => { setResults(null); setName(''); }} style={{ width: 60, height: 60, borderRadius: '50%', background: 'white', border: 'none', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', fontSize: '1.5rem', cursor: 'pointer' }}>↺</button>
                    </div>
                </div>
            )}

            <style>{`@keyframes slideUp { to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
}
